/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FilterDataDTO { 
    id?: string;
    name?: string;
    order?: number;
    defaultValue?: boolean;
}

